import React, { Component } from 'react';

import './loading-overlay.css'

class SidebarComponent extends Component {
    render () {
        const { loading } = this.props
        return (
            loading ? <div id='loading-overlay'><div id='loading-overlay-text'>Идет загрузка...</div></div> : null
        )
    }
}

export default SidebarComponent


// WEBPACK FOOTER //
// ./src/LoadingOverlayComponent.js